<template>

<svg xmlns="http://www.w3.org/2000/svg"  viewBox="-11.5 780.5 24 24" >
<path d="M2.89,785.27l0.55-0.26c-0.54-0.34-1.13-0.59-1.77-0.74l0.21,0.57C2.24,784.95,2.58,785.09,2.89,785.27z"/>
<path d="M-0.88,784.85l0.21-0.57c-0.64,0.14-1.24,0.39-1.77,0.74l0.55,0.26C-1.58,785.09-1.24,784.95-0.88,784.85z"/>
<path d="M5.26,791.05c-0.01,0.05-0.03,0.1-0.05,0.16c-0.01,0.03-0.02,0.06-0.03,0.09c-0.02,0.06-0.04,0.11-0.06,0.17
	c-0.01,0.02-0.02,0.05-0.03,0.07c-0.03,0.08-0.07,0.16-0.1,0.23c0,0,0,0,0,0c-0.04,0.08-0.08,0.16-0.12,0.23
	c0,0.01-0.01,0.01-0.01,0.01l1.12,2.41v-3.68L5.27,791C5.27,791.02,5.27,791.03,5.26,791.05z"/>
<path d="M4.85,787.23c0.17,0.32,0.32,0.66,0.42,1.01l0.57,0.21c-0.14-0.64-0.39-1.24-0.74-1.77L4.85,787.23z"/>
<path d="M3.67,794.33v6.57l-1.7-0.78v-5.24c0.53-0.15,1.03-0.37,1.48-0.66l-0.55-0.26c-0.29,0.16-0.6,0.3-0.93,0.4
	c-0.03,0.01-0.05,0.01-0.08,0.02l-0.91,2.5l-0.47,1.3l-0.47-1.3l-0.91-2.5c-0.03-0.01-0.05-0.01-0.08-0.02
	c-0.33-0.1-0.64-0.23-0.93-0.4l-0.55,0.26c0.45,0.29,0.95,0.52,1.48,0.67v5.24l-1.7,0.78v-6.57l-1.64,0.76l-0.67,0.31v7.11l5.47-2.5
	l5.48,2.49v-7.11l-0.67-0.31L3.67,794.33z"/>
<path d="M-3.98,791.77L-3.98,791.77c-0.04-0.08-0.07-0.16-0.1-0.23c-0.01-0.03-0.02-0.05-0.03-0.07c-0.02-0.06-0.04-0.11-0.06-0.17
	c-0.01-0.03-0.02-0.06-0.03-0.09c-0.02-0.05-0.03-0.1-0.05-0.16c0-0.01-0.01-0.03-0.01-0.04l-0.7-0.26v3.67l1.12-2.41
	c0,0-0.01-0.01-0.01-0.01C-3.9,791.93-3.94,791.85-3.98,791.77z"/>
<path d="M-3.85,787.23l-0.26-0.55c-0.34,0.54-0.59,1.13-0.73,1.77l0.57-0.21C-4.17,787.88-4.03,787.54-3.85,787.23z"/>
<polygon points="2.79,787.33 4.04,787.79 5.52,784.6 2.33,786.08 "/>
<polygon points="-1.79,787.33 -1.34,786.08 -4.52,784.6 -3.04,787.79 "/>
<polygon points="-1.79,791.91 -3.04,791.46 -4.52,794.64 -1.34,793.16 "/>
<polygon points="4.04,791.46 2.79,791.91 2.33,793.16 5.52,794.64 "/>
<polygon points="0.5,788.6 2.39,787.72 0.5,782.52 -1.39,787.72 "/>
<polygon points="2.4,787.72 1.52,789.62 2.4,791.51 7.6,789.62 "/>
<polygon points="-0.52,789.62 -1.4,787.72 -6.6,789.62 -1.4,791.51 "/>
<polygon points="2.39,791.52 0.5,790.63 -1.39,791.52 0.5,796.72 "/>
</svg>

</template>